import { render, staticRenderFns } from "./tbColumns.vue?vue&type=template&id=53569c83&scoped=true"
import script from "./tbColumns.vue?vue&type=script&lang=js"
export * from "./tbColumns.vue?vue&type=script&lang=js"
import style0 from "./tbColumns.vue?vue&type=style&index=0&id=53569c83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53569c83",
  null
  
)

export default component.exports